import { Card } from './Card';
import { CountUp } from './CountUp';
import { Pill } from './Pill';
import { fmtNum } from '../lib/format';

interface Props {
  label: string;
  value: number;
  format?: (n: number) => string;
  decimals?: number;
  delta?: number | null;
  sublabel?: string;
  accent?: boolean;
  trigger?: number;
}

export function KpiCard({
  label,
  value,
  format = fmtNum,
  decimals = 0,
  delta,
  sublabel,
  accent,
  trigger,
}: Props) {
  return (
    <Card padding={18} style={{ display: 'flex', flexDirection: 'column', gap: 10, position: 'relative', overflow: 'hidden' }}>
      {accent && (
        <div
          aria-hidden
          style={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            background: 'radial-gradient(140% 90% at 100% 0%, var(--brand-soft), transparent 55%)',
            opacity: 0.7,
          }}
        />
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div
          style={{
            fontSize: 12,
            color: 'var(--ink-3)',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            fontWeight: 500,
          }}
        >
          {label}
        </div>
        {delta != null && (
          <Pill tone={delta >= 0 ? 'good' : 'bad'} size="sm">
            <span style={{ fontFamily: 'var(--font-mono)' }}>
              {delta >= 0 ? '▲' : '▼'} {Math.abs(delta).toFixed(1)}%
            </span>
          </Pill>
        )}
      </div>
      <div
        style={{
          position: 'relative',
          fontFamily: 'var(--font-display)',
          fontWeight: 600,
          fontSize: 32,
          letterSpacing: '-0.03em',
          color: 'var(--ink)',
        }}
      >
        <CountUp value={value} format={format} decimals={decimals} trigger={trigger} />
      </div>
      {sublabel && <div style={{ position: 'relative', fontSize: 12, color: 'var(--ink-3)' }}>{sublabel}</div>}
    </Card>
  );
}
